import { createContext } from 'react';
import EditSitefConfigContext from 'types/contexts/EditSitefConfigContext';

export default createContext({} as EditSitefConfigContext);
